import React, { useEffect } from "react";
import { useLocation } from "react-router-dom";
import LdsButton from "../../components/LdsButton";
import { SideBar } from "../../components/SideBar";
import { useSelector } from "react-redux";

import { ReactLoaderSpinner } from "../../components/ReactLoaderSpinner/index.js";
import LdsImage from "../../components/LdsImage";
import contrast from "../../assets/module-2/2-4-2-contrast.png";

// services
import { useBookmarkModuleMutation } from "../../store/services/moduleServerApi";

const Module_2_1_1 = () => {
  const { pathname: pathName } = useLocation();
  const { menuItems } = useSelector((state) => state?.moduleSlice);

  const [bookmarkModule, { isLoading: isMenuLoading }] =
    useBookmarkModuleMutation();

  /* Start useEffect */
  useEffect(() => {
    bookmarkModule({ pathName });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []); // * onPageLoad
  /* End useEffect */

  return (
    <div className="row">
      {isMenuLoading && <ReactLoaderSpinner />}
      {menuItems?.id && <SideBar menuItems={[menuItems]} />}
      <div className="col-sm-8">
        <main className="module-content">
          <section>
            <h1 className="blue text-uppercase b mt-5 mb-4">
              2.4.2 Contrast Test: PC and Mac Only
            </h1>
            <p className="me-4">Estimated time to complete: 1 minute</p>
          </section>

          <section className="row justify-content-center mt-5 mb-5">
            <div className="col-lg-6 col-md-12">
              <LdsImage
                src={contrast}
                style={{ maxWidth: 354 }}
                alt="A calibration chart showing a grid of grayscale squares from dark to light, with a checkerboard pattern below, transitioning from darker to lighter shades."
              />
            </div>
          </section>

          <section className="row justify-content-center">
            <div className="col-lg-8 col-md-12">
              <h5 className="b">Black Level</h5>
              <ul className="mse">
                <li>
                  On an ideal monitor, you should be able to distinguish every
                  square
                </li>
                <li>
                  At a minimum, you should be able to distinguish up to Square
                  #5
                </li>
              </ul>

              <h5 className="b">White Saturation</h5>
              <ul className="mse">
                <li>
                  You should be able to distinguish each checkerboard pattern
                  from the background{" "}
                </li>
                <li>At a minimum, you should be able to distinguish up to Square 252</li>
              </ul>
              <p>
                Before you view your first practice case, bear in mind that
                proper screen contrast is important for accurate image review.
                We have provided calibration images here for your reference.
                Please refer to the owner’s manual for your computer or display
                for instructions on how to adjust image contrast if necessary.
              </p>
              <p>
                If you are on an iPad, you do not need to adjust your contrast,
                but please note that contrast is an important aspect of accurate
                reads, and you will be responsible for adjusting the contrast
                within the Mobile MIM app.
              </p>
            </div>
          </section>

          <section className="button-control">
            <LdsButton
              classes="white-button mt-3 mb-3 prev"
              onClick={function navClick() {
                window.open("/module-2/module-2-4-1", "_self");
              }}
            >
              Previous Lesson
            </LdsButton>
            <LdsButton
              classes="blue-button mt-3 mb-5 align-self-right float-end next"
              onClick={function navClick() {
                window.open("/module-2/module-2-4-3", "_self");
              }}
            >
              Next Lesson
            </LdsButton>
          </section>
          <section></section>
        </main>
      </div>
    </div>
  );
};

export default Module_2_1_1;
